<script setup lang="ts">
import { inject, Ref } from 'vue';

const dialogRef = inject('dialogRef') as Ref;
const message = dialogRef?.value?.data?.message;
const subMessage = dialogRef?.value?.data?.subMessage;
const title = dialogRef?.value?.data?.title;
const isAlignCenter = dialogRef?.value.data.isAlignCenter;
const isTour = dialogRef?.value.data.isTour;
</script>
<template>
  <div :class="[`common-modal pt-2  w-full ${isAlignCenter && 'text-center'}`]">
    <div class="mb-2 font-bold text-2xl">{{ title }}</div>
    <div class="flex flex-column justify-content-center align-items-center">
      <div :class="isTour ? 'title-message' : ''">{{ message }}</div>
      <div v-if="subMessage" class="pt-2 text-center">{{ subMessage }}</div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.common-modal {
  width: min(500px, 90vw);
}
.title-message {
  font-size: 18px;
  font-weight: bold;
}
</style>
